import Navbar from "../components/Navbar";
import React, {useEffect, useState} from "react";
import {motion} from "framer-motion";
import Footer from "../components/Footer";
import TurboProp from "../assets/images/672cd8185dd90700a1834dbf_2TURBOPROP-p-1080_upscayl_3x_realesrgan-x4plus.webp";
import UltraLong from "../assets/images/6727d80fae56b39e24228388_CORPOAIRLINER-p-1600_upscayl_3x_realesrgan-x4plus.webp";
import Heavy from "../assets/images/6727d6b5ac6214ff0107fc98_FALCON7XULTRALONGRANGE-p-1080_upscayl_3x_realesrgan-x4plus.webp";
import Transition from "../components/Transition";
import {useNavigate} from "react-router-dom";
import Light from "../assets/images/light_upscayl_3x_realesrgan-x4plus.webp";
import Medium from "../assets/images/Medium_upscayl_3x_realesrgan-x4plus.webp";
import {FaArrowRight} from "react-icons/fa";
import PicRow1 from "../assets/images/rapide.png";
import PicRow2 from "../assets/images/appel-telephonique.png";
import PicRow3 from "../assets/images/bouclier.png";
import ServicesJson from "../assets/jsons/services.json";
import TestimonialsJson from "../assets/jsons/testimonials.json";
import GlobalJson from "../assets/jsons/Global.json";
import FleetJson from "../assets/jsons/fleet.json";

const jets = [
    {
        category: "Turboprops",
        name: "Phenom 100",
        fullName: "PHENOM 100",
        capacity: "4+1",
        duration: "2h30",
        range: 2000,
        luggage: 4,
        cabinHeight: 1.5
    },
    {
        category: "Light Jets",
        name: "Citation CJ2+",
        fullName: "CITATION CJ2+",
        capacity: 6,
        duration: "3h15",
        range: 2652,
        luggage: 6,
        cabinHeight: 1.45
    },
    {
        category: "Light Jets",
        name: "Citation CJ2+",
        fullName: "CITATION CJ2+",
        capacity: 6,
        duration: "3h15",
        range: 2652,
        luggage: 6,
        cabinHeight: 1.45
    },
    {
        category: "Medium Jets",
        name: "Phenom 100",
        fullName: "PHENOM 100",
        capacity: "4+1",
        duration: "2h30",
        range: 2000,
        luggage: 4,
        cabinHeight: 1.5
    },
    {
        category: "Medium Jets",
        name: "Phenom 100",
        fullName: "PHENOM 100",
        capacity: "4+1",
        duration: "2h30",
        range: 2000,
        luggage: 4,
        cabinHeight: 1.5
    },
    {
        category: "Medium Jets",
        name: "Phenom 100",
        fullName: "PHENOM 100",
        capacity: "4+1",
        duration: "2h30",
        range: 2000,
        luggage: 4,
        cabinHeight: 1.5
    },
    {
        category: "Heavy Jets",
        name: "Phenom 100",
        fullName: "PHENOM 100",
        capacity: "4+1",
        duration: "2h30",
        range: 2000,
        luggage: 4,
        cabinHeight: 1.5
    },
    {
        category: "Heavy Jets",
        name: "Phenom 100",
        fullName: "PHENOM 100",
        capacity: "4+1",
        duration: "2h30",
        range: 2000,
        luggage: 4,
        cabinHeight: 1.5
    },
    {
        category: "Heavy Jets",
        name: "Phenom 100",
        fullName: "PHENOM 100",
        capacity: "4+1",
        duration: "2h30",
        range: 2000,
        luggage: 4,
        cabinHeight: 1.5
    },
    {
        category: "Ultra Long Range",
        name: "Phenom 100",
        fullName: "PHENOM 100",
        capacity: "4+1",
        duration: "2h30",
        range: 2000,
        luggage: 4,
        cabinHeight: 1.5
    },
];

const pics = [
    TurboProp,
    Light,
    Medium,
    Heavy,
    UltraLong
];

const GOLD = "#C1A45F";

const services = [
    {
        title: "Réactivité absolue",
        desc: "Nous répondons et organisons en quelques minutes, 24/7.",
        img: PicRow1,
    },
    {
        title: "Disponibilité sur-mesure",
        desc: "Un interlocuteur unique, présent à chaque étape.",
        img: PicRow2,
    },
    {
        title: "Discrétion & sécurité",
        desc: "Standards premium de sécurité et confidentialité.",
        img: PicRow3,
    },
];

const testimonials = [
    {
        name: "Lucien D.",
        role: "Dirigeant",
        quote:
            "Avanty Jet a transformé un déplacement banal en un moment d’exception. Discrétion, précision, excellence.",
    },
    {
        name: "Élodie S.",
        role: "Influenceuse voyage",
        quote:
            "Jamais je n’avais vécu un service aussi personnalisé — du sur-mesure à l’état pur.",
    },
];

function SectionTitle({ eyebrow, title, subtitle }) {
    return (
        <div className="text-center">
            {eyebrow && <p className="uppercase text-sm tracking-widest text-white/60 mb-2">{eyebrow}</p>}
            <h2 className="text-3xl sm:text-4xl font-extrabold" style={{ color: GOLD }}>{title}</h2>
            {subtitle && <p className="mt-3 text-white/80 max-w-4xl mx-auto">{subtitle}</p>}
        </div>
    );
}

function DemanderDevisButton({language}) {
    const navigate = useNavigate();

    return (
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="flex justify-center cursor-pointer">
            <a
                onClick={() => navigate("/#quotation")}
                className="px-10 py-4 rounded-full bg-white text-black font-semibold shadow-lg flex items-center hover:bg-gray-100 transition"
            >
                {GlobalJson.availableLanguages[language].ctaButton}
                <FaArrowRight className="ml-2" />
            </a>
        </motion.div>
    );
}

export function MainContent({language, setLanguage}) {
    const navigate = useNavigate();

    const groupedJets = jets.reduce((acc, jet) => {
        if (!acc[jet.category]) acc[jet.category] = [];
        acc[jet.category].push(jet);
        return acc;
    }, {});

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7 }}
            className="flex-1 z-10"
        >
            <div className="relative z-20">
                <Navbar language={language} setLanguage={setLanguage} />
            </div>
            <div className="bg-myDarkBlue w-full flex flex-col items-center relative z-[1] pt-40">
                <div className="bg-myDarkBlue w-full flex flex-col items-center relative z-[1]">
                    <div className="w-full pt-32 space-y-32">

                        {/* Intro Section */}
                        <section className="text-center px-6 sm:px-10 max-w-[1586px] mx-auto">
                            <motion.h1
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}
                                className="text-4xl sm:text-6xl font-extrabold tracking-tight leading-tight text-white"
                            >
                                {FleetJson.availableLanguages[language].fleet.introTitle1}
                                <span className="text-[#C1A45F]"> {FleetJson.availableLanguages[language].fleet.introTitle2}</span>
                                {FleetJson.availableLanguages[language].fleet.introTitle3}
                            </motion.h1>
                            <p className="mt-6 text-lg sm:text-xl text-white/70 max-w-3xl mx-auto">
                                {FleetJson.availableLanguages[language].fleet.introSubtitle}
                            </p>
                        </section>

                        {/* Intro Text */}
                        <div className={"w-full bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue"}>
                            <div className="max-w-5xl mx-auto text-center px-6 sm:px-14">
                                <p className="font-semibold text-2xl mb-5 text-white">{FleetJson.availableLanguages[language].fleet.introTextTitle}</p>
                                <p className="text-white/80">{FleetJson.availableLanguages[language].fleet.introText}</p>
                                <p className="mt-4 font-semibold text-white/90">{FleetJson.availableLanguages[language].fleet.introText2}</p>
                            </div>
                        </div>

                        {/* Fleet Categories */}
                        {/* Fleet Categories */}
                        {FleetJson.availableLanguages[language].fleet.categories.map((category, index) => (
                            <div key={index} className="w-full">
                                <section
                                    className={`flex flex-col md:flex-row items-center gap-10 px-6 sm:px-10 bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue ${
                                        index % 2 !== 0 ? 'md:flex-row-reverse' : ''
                                    }`}
                                >
                                    {/* Image */}
                                    <motion.img
                                        src={pics[index]} // assign your images here: Light, Medium, Heavy...
                                        alt={category.title}
                                        initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.7, delay: 0.2 }}
                                        className="w-full md:w-1/2 rounded-xl shadow-lg object-cover"
                                    />

                                    {/* Text Card */}
                                    <motion.div
                                        className="bg-black/60 text-white p-8 rounded-xl flex flex-col justify-center md:max-w-xl shadow-lg"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.7, delay: 0.3 }}
                                    >
                                        <h2 className="text-2xl font-bold border-b-4 border-[#C1A45F] pb-2 w-max mb-4">{category.title}</h2>
                                        <p className="mb-4 text-justify">{category.text}</p>
                                        <p className="font-semibold text-[#C1A45F]">{category.examples}</p>
                                    </motion.div>
                                </section>

                                {/* Divider */}
                                {index !== FleetJson.availableLanguages[language].fleet.categories.length - 1 && (
                                    <div className="my-24 border-t border-white/20 w-2/4 mx-auto"></div>
                                )}
                            </div>
                        ))}


                    </div>
                </div>

            </div>
            {/* BRAND PROMISE */}
            <section className="pb-16 pt-32 bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue">
                <div className="max-w-7xl mx-auto px-6">
                    <SectionTitle
                        eyebrow={ServicesJson.availableLanguages[language].title1}
                        title={ServicesJson.availableLanguages[language].title2}
                        subtitle={ServicesJson.availableLanguages[language].title3}
                    />

                    <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                        {services.map((s, i) => (
                            <motion.div
                                key={i}
                                whileHover={{y: -6}}
                                className="p-6 rounded-2xl bg-black/20 border border-white/20 shadow-lg"
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div className="flex items-center gap-4">
                                    <img src={s.img} alt={s.title} className="w-16 h-16"/>
                                    <div>
                                        <h4 className="text-xl font-semibold text-white">{ServicesJson.availableLanguages[language].services[i].title}</h4>
                                        <p className="text-white/75 mt-1">{ServicesJson.availableLanguages[language].services[i].desc}</p>
                                    </div>
                                </div>
                                <div className="mt-6 text-sm text-white/60 flex justify-center">
                                    {ServicesJson.availableLanguages[language].services[i].bottom}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* TESTIMONIALS */}
            <section className="py-16 bg-myDarkBlue">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <SectionTitle eyebrow={TestimonialsJson.availableLanguages[language].title}
                                  title={TestimonialsJson.availableLanguages[language].subtitle}/>

                    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                initial={{opacity: 0, y: 20}}
                                whileInView={{opacity: 1, y: 0}}
                                whileHover={{y: -6}}
                                viewport={{once: true}}
                                className="relative p-6 rounded-2xl bg-black/20 border border-white/10 overflow-hidden bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]"
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div
                                    className="absolute -top-4 left-0 w-full h-4 pointer-events-none"
                                    style={{
                                        boxShadow: "0 0 10px 2px rgba(255, 255, 255, 0.2)",
                                        maskImage: "linear-gradient(to bottom, white, transparent)",
                                        WebkitMaskImage: "linear-gradient(to bottom, white, transparent)"
                                    }}
                                />

                                <p className="italic text-white/80">{TestimonialsJson.availableLanguages[language].testimonials[i].quote}</p>
                                <p className="mt-4 font-semibold text-white">{TestimonialsJson.availableLanguages[language].testimonials[i].author}</p>
                                <p className="text-sm text-white/60">{TestimonialsJson.availableLanguages[language].testimonials[i].role}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="pt-10 pb-32 bg-myDarkBlue text-center">
                <h2 className="text-4xl font-extrabold mb-4"
                    style={{color: GOLD}}>{GlobalJson.availableLanguages[language].ctaTitle}</h2>
                <p className="text-white/80 max-w-2xl mx-auto mb-8">{GlobalJson.availableLanguages[language].contact}</p>
                <div className="flex items-center justify-center gap-4">
                    <DemanderDevisButton language={language}/>
                </div>
            </section>
            <Footer language={language} />
        </motion.div>

    );
}

export function Fleet({language, setLanguage}) {
    const [isTransitionVisible, setIsTransitionVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTransitionVisible(false);
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {isTransitionVisible ? (
                <Transition/>
            ) : (
                <MainContent language={language} setLanguage={setLanguage}/>
            )}
        </div>
    );
}